import React, { useRef, useEffect } from 'react';
import './style.scss';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Dialog } from '@progress/kendo-react-dialogs';

function preventEnterKey(e) {
  if (e?.key === 'Enter') {
    e.preventDefault();
  }
}

const Modal = ({
  isOpen,
  title,
  children,
  handleClose,
  backDropStyle,
  containerStyle,
  style,
  disableEnter = true,
  // If fluid = true - removes padding from the body
  fluid = false,
  ...props
}) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current?.element) {
      if (disableEnter) {
        ref.current?.element?.addEventListener('keydown', preventEnterKey);
      } else {
        ref.current?.element?.removeEventListener('keydown', preventEnterKey);
      }
    }

    return () => {
      ref.current?.element?.removeEventListener('keydown', preventEnterKey);
    };
  }, [disableEnter]);

  const dialogClassName = cn({
    [containerStyle]: !!containerStyle,
    'fluid-modal': fluid,
  });

  return isOpen && (
    <Dialog
      ref={(elemRef) => {
        ref.current = elemRef;
        if (disableEnter) {
          ref.current?.element?.addEventListener('keydown', preventEnterKey);
        } else {
          ref.current?.element?.removeEventListener('keydown', preventEnterKey);
        }
      }}
      title={title}
      onClose={handleClose}
      className={dialogClassName}
      contentStyle={style}
      appendTo={document.getElementById('root')}
      {...props}
    >
      {
        children
      }
    </Dialog>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  // Force the user to override with an empty function if we don't want this.
  // Specifically used for esc to close modal
  handleClose: PropTypes.func,
  children: PropTypes.node,
  containerStyle: PropTypes.string,
};

export default Modal;
